(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["key-facts-horizontal"] && !Shopify.designMode) return;
  try {
    
  // JavaScript to handle automatic sliding on mobile devices
  (function() {
    var benefits = document.querySelector('.Benefits');
    var benefitsCarousel = document.querySelector('.BenefitsCarousel');
    var isMobile = null;
    var animationFrameId = null;

    if (benefits && benefitsCarousel) {
      // Save original content once, regardless of screen size
      benefits.originalContent = benefits.innerHTML;
    }

    function initBenefitsCarousel() {
      if (benefits && benefitsCarousel) {
        var currentIsMobile = window.innerWidth < 1008;

        if (currentIsMobile !== isMobile) {
          isMobile = currentIsMobile;

          // Cancel any ongoing animation
          if (animationFrameId) {
            cancelAnimationFrame(animationFrameId);
            animationFrameId = null;
          }

          // Reset content and styles
          benefits.style.transform = 'translateX(0)';
          benefits.innerHTML = benefits.originalContent;

          if (isMobile) {
            // Clone the benefits to create a seamless loop
            benefits.innerHTML += benefits.innerHTML;

            var benefitsWidth = benefits.scrollWidth / 2; // Width of the original items
            var scrollAmount = 0;

            function animateBenefits() {
              scrollAmount += 0.5; // Adjust this value to control speed
              if (scrollAmount >= benefitsWidth) {
                scrollAmount = 0; // Reset scroll amount to loop
              }
              benefits.style.transform = 'translateX(' + (-scrollAmount) + 'px)';
              animationFrameId = requestAnimationFrame(animateBenefits);
            }

            animateBenefits();
          } else {
            // On desktop, ensure benefits display correctly
            benefits.style.transform = 'translateX(0)';
          }
        }
      }
    }

    // Initialize on page load
    initBenefitsCarousel();

    // Re-initialize on window resize
    window.addEventListener('resize', function() {
      initBenefitsCarousel();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
